"use strict";

/**
 * Mobile header banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Only on mobile */ && FlixUtils.isMobile();
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    if (Flix.isTna()) {
      var el = document.querySelector('#bannerBlock_head');
      if (!el) {
        return;
      }
      el.innerHTML = '<div class="ad-logo">Ad</div>';
      var s = document.createElement('script');
      s.src = '//bullionglidingscuttle.com/lv/esnk/1867854/code.js';
      s.type = 'text/javascript';
      s.async = true;
      s.id = '__clb-1867854';
      s.setAttribute('data-cfasync', false);
      s.onerror = function () {
        return FlixStats.increment('ad_error_header');
      };
      // s.onload = () => FlixStats.increment('ad_header_ok');

      el.appendChild(s);
    } else {
      var code = "<div class=\"ad-logo\">Ad</div>\n                <iframe class=\"na\" frameborder=\"0\" scrolling=\"no\" width=\"300\" height=\"100\" sandbox=\"allow-scripts allow-popups allow-forms allow-same-origin\" \n                src=\"//a.shukriya90.com/api/spots/350856?p=1&s1=".concat(Flix.ads.iid, "&kw=").concat(Flix.ads.tags, "\"></iframe>");
      if (document.querySelector('#bannerBlock_head')) {
        document.querySelector('#bannerBlock_head').innerHTML = code;
      }

      // Add 2nd header banner on the 5th row for mediabuys
      if (!Flix.ads.isOrganic() && document.querySelector('.video-list [data-num="4"]')) {
        document.querySelector('.video-list [data-num="4"]').insertAdjacentHTML('afterend', "<div class=\"bannerBlock\" id=\"bannerBlock_head2\">".concat(code, "</div>"));
      }
    }
  }
  ;
})();